/* Carrinho Navita (fase 7c) — carrinho lateral e página do carrinho.
   1. "+" das sugestões (snippets/navita-carrinho-sugestoes.liquid) e preço da opção escolhida.
   2. "Vai ser para oferecer?" (snippets/navita-carrinho-oferta.liquid): embrulho, saco e cartão com mensagem.
   3. Prazo de envio ("sai hoje / amanhã / segunda-feira"), pela hora de Lisboa.
   Depois de cada mudança avisa o tema (CartLinesUpdateEvent), que volta a desenhar o carrinho sem recarregar a página.
   Carrega sempre com o carrinho, porque o tema redesenha o carrinho sem executar scripts. */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.navitaCarrinhoPronto) {
  window.navitaCarrinhoPronto = true;
  const raiz = () => window.Shopify?.routes?.root || '/';
  const lingua = document.documentElement.lang || '';
  const es = lingua.startsWith('es');
  const en = lingua.startsWith('en');

  async function pedido(url, corpo) {
    const r = await fetch(raiz() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo),
    });
    if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || r.status);
    return r.json();
  }

  // o tema vai buscar o carrinho de novo e redesenha-o (action "add" abre o carrinho lateral, se estiver fechado)
  function avisar(origem, acao, id, quantidade) {
    const promessa = CartLinesUpdateEvent.createPromise();
    origem.dispatchEvent(new CartLinesUpdateEvent({
      action: acao, context: 'cart',
      lines: [{ merchandiseId: String(id), quantity: quantidade }],
      promise: promessa.promise,
    }));
    promessa.resolve({ detail: {} });
  }

  /* 1. Sugestões */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('.navita-carrinho__item select[data-navita-var]');
    if (!sel) return;
    const preco = sel.selectedOptions[0]?.dataset.preco;
    const alvo = sel.closest('.navita-carrinho__item').querySelector('[data-navita-preco]');
    if (preco && alvo) alvo.textContent = preco;
  });

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-navita-juntar]');
    if (!b) return;
    const item = b.closest('.navita-carrinho__item');
    const id = Number(item.querySelector('[data-navita-var]').value);
    b.disabled = true;
    b.textContent = '…';
    try {
      await pedido('cart/add.js', { items: [{ id, quantity: 1 }] });
      avisar(b, 'add', id, 1);
    } catch (erro) {
      b.disabled = false;
      b.textContent = '+';
    }
  });

  /* 2. Oferta */
  document.addEventListener('change', async (e) => {
    const check = e.target.closest('[data-ncar-presente-check]');
    if (!check) return;
    const op = check.closest('[data-ncar-presente]');
    const id = Number(op.dataset.variantId);
    const msg = op.querySelector('[data-ncar-msg]');
    check.disabled = true;
    try {
      if (check.checked) {
        await pedido('cart/add.js', { items: [{ id, quantity: 1 }] });
        if (msg) msg.hidden = false;
        avisar(check, 'add', id, 1);
      } else if (op.dataset.lineKey) {
        await pedido('cart/change.js', { id: op.dataset.lineKey, quantity: 0 });
        avisar(check, 'change', id, 0);
      }
    } catch (erro) {
      check.checked = !check.checked;
    }
    check.disabled = false;
  });

  document.addEventListener('input', (e) => {
    const t = e.target.closest('[data-ncar-msg-texto]');
    if (!t) return;
    const conta = t.closest('[data-ncar-msg]').querySelector('[data-ncar-msg-conta]');
    if (conta) conta.textContent = t.value.length;
  });

  // Grava a mensagem do cartão na linha do carrinho (propriedade "Mensagem"). Devolve true se correu bem.
  const aGuardar = new Map();
  async function guardarMensagem(op) {
    const caixa = op.querySelector('[data-ncar-msg]');
    const estado = caixa.querySelector('[data-ncar-msg-estado]');
    const mensagem = caixa.querySelector('[data-ncar-msg-texto]').value.trim();
    if (aGuardar.has(op.dataset.variantId)) return aGuardar.get(op.dataset.variantId);
    const promessa = (async () => {
      try {
        // a linha pode ter mudado de chave depois de redesenhar: procura-a pelo id da variante
        const carrinho = await fetch(raiz() + 'cart.js').then((r) => r.json());
        const linha = carrinho.items.find((i) => String(i.variant_id) === op.dataset.variantId);
        if (linha) {
          await pedido('cart/change.js', { id: linha.key, quantity: linha.quantity, properties: { Mensagem: mensagem } });
        } else {
          await pedido('cart/add.js', { items: [{ id: Number(op.dataset.variantId), quantity: 1, properties: { Mensagem: mensagem } }] });
        }
        caixa.dataset.ncarMsgGuardada = mensagem;
        if (estado) estado.textContent = mensagem ? (es ? '✓ Mensaje guardado' : en ? '✓ Message saved' : '✓ Mensagem guardada') : '';
        return true;
      } catch (erro) {
        if (estado) estado.textContent = es ? 'No se ha podido guardar. Inténtalo de nuevo.' : en ? 'Could not save. Please try again.' : 'Não foi possível guardar. Tenta outra vez.';
        return false;
      } finally {
        aGuardar.delete(op.dataset.variantId);
      }
    })();
    aGuardar.set(op.dataset.variantId, promessa);
    return promessa;
  }

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-ncar-msg-guardar]');
    if (!b) return;
    const op = b.closest('[data-ncar-presente]');
    b.disabled = true;
    if (await guardarMensagem(op)) avisar(b, 'change', op.dataset.variantId, 1);
    b.disabled = false;
  });

  // Ao sair da caixa da mensagem, grava sozinha (não depende de carregar em "Guardar").
  document.addEventListener('change', async (e) => {
    const t = e.target.closest('[data-ncar-msg-texto]');
    if (!t) return;
    const op = t.closest('[data-ncar-presente]');
    const caixa = t.closest('[data-ncar-msg]');
    if (t.value.trim() === (caixa.dataset.ncarMsgGuardada || '')) return;
    if (t.value.trim()) limparErro(caixa);
    if (await guardarMensagem(op)) avisar(t, 'change', op.dataset.variantId, 1);
  });

  /* 2c. Cartão com mensagem: a mensagem é obrigatória (produto do cartão, "Vai ser para oferecer?" e carrinho). */
  function parar(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
  function mostrarErro(caixa, texto, detalhes) {
    if (detalhes) detalhes.open = true;
    caixa.hidden = false;
    caixa.classList.add('is-erro');
    const erro = caixa.querySelector('[data-ncar-msg-erro], [data-ncar-cartao-erro]');
    if (erro) {
      if (erro.matches('[data-ncar-cartao-erro]')) erro.textContent = texto.dataset.ncarAviso || '';
      erro.hidden = false;
    }
    texto.focus({ preventScroll: true });
    texto.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  function limparErro(caixa) {
    caixa.classList.remove('is-erro');
    caixa.querySelectorAll('[data-ncar-msg-erro], [data-ncar-cartao-erro]').forEach((el) => { el.hidden = true; });
  }

  // (a) Página do próprio cartão: o campo é obrigatório (required). Mostra o nosso aviso em vez do balão do navegador.
  document.addEventListener('invalid', (e) => {
    const t = e.target.closest?.('[data-ncar-obrigatoria]');
    if (!t) return;
    e.preventDefault();
    mostrarErro(t.closest('[data-ncar-cartao-campo]'), t);
  }, true);
  document.addEventListener('input', (e) => {
    const t = e.target.closest('[data-ncar-obrigatoria]');
    if (t) {
      const campo = t.closest('[data-ncar-cartao-campo]');
      campo.querySelector('[data-ncar-cartao-conta]').textContent = t.value.length;
      if (t.value.trim()) limparErro(campo);
      return;
    }
    const m = e.target.closest('[data-ncar-produto-msg-texto], [data-ncar-msg-texto]');
    if (m && m.value.trim()) limparErro(m.closest('[data-ncar-produto-msg], [data-ncar-msg]'));
  });

  // (b) Formulário de compra: cartão sem mensagem não entra no carrinho.
  // Na janela (window) e em captura: corre antes do tema, que trata o envio no document também em captura.
  window.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
    const campo = form.querySelector('[data-ncar-obrigatoria]');
    if (campo && !campo.value.trim()) {
      parar(e);
      mostrarErro(campo.closest('[data-ncar-cartao-campo]'), campo);
      return;
    }
    const caixa = document.querySelector('[data-ncar-oferta-produto]');
    if (!caixa || caixa.closest('.shopify-section') !== form.closest('.shopify-section')) return;
    for (const o of caixa.querySelectorAll('[data-ncar-produto-presente]')) {
      const marcado = o.querySelector('[data-ncar-produto-check]')?.checked;
      const texto = o.querySelector('[data-ncar-produto-msg-texto]');
      if (marcado && texto && !texto.value.trim()) {
        parar(e);
        mostrarErro(o.querySelector('[data-ncar-produto-msg]'), texto, caixa);
        return;
      }
    }
  }, true);

  // (c) Carrinho: "Finalizar compra" só avança com a mensagem do cartão escrita (e gravada).
  function cartaoPorResolver(origem) {
    const zona = origem.closest('#cart-drawer, cart-drawer-component, .cart-drawer, main') || document;
    for (const op of zona.querySelectorAll('[data-ncar-presente]')) {
      const caixa = op.querySelector('[data-ncar-msg]');
      if (!caixa || !op.querySelector('[data-ncar-presente-check]')?.checked) continue;
      const texto = caixa.querySelector('[data-ncar-msg-texto]');
      const valor = texto.value.trim();
      if (!valor) return { op, caixa, texto, vazio: true };
      if (valor !== (caixa.dataset.ncarMsgGuardada || '')) return { op, caixa, texto, vazio: false };
    }
    return null;
  }
  window.addEventListener('click', async (e) => {
    const b = e.target.closest?.('button[name="checkout"], #checkout, a[href$="/checkout"]');
    if (!b) return;
    const p = cartaoPorResolver(b);
    if (!p) return;
    parar(e);
    if (p.vazio) {
      mostrarErro(p.caixa, p.texto, p.op.closest('[data-ncar-oferta]'));
      return;
    }
    // escreveu mas não gravou: grava e segue para a finalização da compra
    b.disabled = true;
    const ok = await guardarMensagem(p.op);
    b.disabled = false;
    if (ok) location.href = raiz() + 'checkout';
  }, true);

  /* 2b. "Vai ser para oferecer?" na página de produto (blocks/navita-oferta.liquid):
     o que estiver marcado entra no carrinho logo a seguir ao produto, só se o produto entrar sem erro. */
  function resumoOferta(caixa) {
    const nomes = [...caixa.querySelectorAll('[data-ncar-produto-presente]')]
      .filter((o) => o.querySelector('[data-ncar-produto-check]').checked)
      .map((o) => o.querySelector('.ncar-oferta__txt b').textContent.trim().toLowerCase());
    const alvo = caixa.querySelector('[data-ncar-oferta-resumo]');
    if (alvo) alvo.textContent = nomes.length ? '· ' + nomes.join(' + ') : '';
  }
  document.addEventListener('change', (e) => {
    const check = e.target.closest('[data-ncar-produto-check]');
    if (!check) return;
    const op = check.closest('[data-ncar-produto-presente]');
    const msg = op.querySelector('[data-ncar-produto-msg]');
    if (msg) { msg.hidden = !check.checked; if (check.checked) msg.querySelector('textarea')?.focus(); }
    resumoOferta(check.closest('[data-ncar-oferta-produto]'));
  });
  document.addEventListener('input', (e) => {
    const t = e.target.closest('[data-ncar-produto-msg-texto]');
    if (!t) return;
    const conta = t.closest('[data-ncar-produto-msg]').querySelector('[data-ncar-produto-msg-conta]');
    if (conta) conta.textContent = t.value.length;
  });
  document.addEventListener('shopify:cart:lines-update', async (e) => {
    if (e.context !== 'product' || e.action !== 'add') return;
    const caixa = document.querySelector('[data-ncar-oferta-produto]');
    if (!caixa) return;
    const marcados = [...caixa.querySelectorAll('[data-ncar-produto-presente]')].filter((o) => o.querySelector('[data-ncar-produto-check]').checked);
    if (!marcados.length) return;
    let resultado;
    try { resultado = await e.promise; } catch (erro) { return; }
    if (resultado?.detail?.didError) return;
    try {
      const atual = await fetch(raiz() + 'cart.js').then((r) => r.json());
      const items = [];
      for (const o of marcados) {
        if (atual.items.some((i) => String(i.variant_id) === o.dataset.variantId)) continue; // já está no carrinho
        const linha = { id: Number(o.dataset.variantId), quantity: 1 };
        const texto = o.querySelector('[data-ncar-produto-msg-texto]')?.value.trim();
        if (texto) linha.properties = { Mensagem: texto };
        items.push(linha);
      }
      if (items.length) {
        await pedido('cart/add.js', { items });
        avisar(caixa, 'add', items[0].id, 1);
      }
      for (const o of marcados) o.querySelector('[data-ncar-produto-check]').checked = false;
      caixa.querySelectorAll('[data-ncar-produto-msg]').forEach((m) => { m.hidden = true; });
      resumoOferta(caixa);
      caixa.open = false;
    } catch (erro) { /* o produto já entrou; os extras podem juntar-se no carrinho */ }
  });

  /* 3. Prazo de envio (dias úteis) */
  function prazo() {
    for (const el of document.querySelectorAll('.ncar-res__prazo[data-navita-prazo]')) {
      const limite = Number(el.dataset.navitaPrazo) || 13;
      const agora = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Lisbon' }));
      const dia = agora.getDay();
      let txt;
      if (dia >= 1 && dia <= 5 && agora.getHours() < limite) txt = es ? 'sale hoy' : en ? 'it ships today' : 'sai hoje';
      else if (dia >= 1 && dia <= 4) txt = es ? 'sale mañana' : en ? 'it ships tomorrow' : 'sai amanhã';
      else txt = es ? 'sale el lunes' : en ? 'it ships on Monday' : 'sai segunda-feira';
      const alvo = el.querySelector('[data-navita-prazo-txt]');
      if (alvo && alvo.textContent !== txt) alvo.textContent = txt;
    }
  }
  // "Vai ser para oferecer?" do carrinho: aberto quando já há opções no carrinho (uma vez; depois a cliente decide)
  function abrirOferta() {
    for (const d of document.querySelectorAll('[data-ncar-oferta]:not([data-ncar-visto])')) {
      if (d.querySelector('[data-ncar-presente-check]:checked')) d.open = true;
      d.setAttribute('data-ncar-visto', '');
    }
  }
  prazo();
  abrirOferta();
  new MutationObserver(() => { prazo(); abrirOferta(); }).observe(document.body, { childList: true, subtree: true });
  setInterval(prazo, 60000);
}
